// ---
// генерация error на основании ошибки в ответе response
//   зависит от апи, может меняться от проекта к проекту
// ---
class BaseError extends Error {
  constructor (message) {
    super(message);
    this.name = this.constructor.name;
  }
}

import { getApiErrorMessage } from '@/api/get-api-error-message.js';

export class ApiCardsError extends BaseError {
  constructor (message, code) {
    const msg = getApiErrorMessage(code) ?? message;
    super(msg);
    this.code = code;
  }
}

export class ApiError extends BaseError {
  constructor (message, errClass) {
    super(message);
    this.errorClass = errClass;
  }
}

export function throwIfError (response) {
  const apiErr = response?.data?.errors && response?.data?.errors[0];
  // asm, del after 2025-05 console.log('throwIfError response:', response);
  if ((apiErr !== null) && (apiErr !== undefined)) {
    if (apiErr.errorClass === 'ApiCardsResponseError') {
      const err = new ApiCardsError(apiErr.message, apiErr.code);
      // asm, del after 2025-05 console.log('ApiCardsError :', err);
      throw err;
    }
    else {
      const err = new ApiError(apiErr.message ?? 'Api Error', apiErr.errorClass);
      // asm, del after 2025-05 console.log('ApiError :', err);
      throw err;
    }
  }
}

/*
  Является ли ошибка связанной с промокодами
*/
export function isPromoCodeError (error) {
  return ((error instanceof ApiCardsError) && [10101, 10102, 10103].includes(error.code));
}
